import { render, staticRenderFns } from "./UploadFile.vue?vue&type=template&id=057ab22d&scoped=true&"
import script from "./UploadFile.vue?vue&type=script&lang=js&"
export * from "./UploadFile.vue?vue&type=script&lang=js&"
import style0 from "./UploadFile.vue?vue&type=style&index=0&id=057ab22d&lang=scss&scoped=true&"
import style1 from "./UploadFile.vue?vue&type=style&index=1&id=057ab22d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057ab22d",
  null
  
)

export default component.exports